import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTenantContent } from "../Context/TenantContentContext";

const NotFound = () => {
  const { content } = useTenantContent();
  const siteName = content?.siteName || "سایت پزشک";

  return (
    <>
      <Helmet>
        <title>{`صفحه پیدا نشد | ${siteName}`}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="container py-5 text-center iran-sans">
        <h1 className="color-blue fw-bold mb-3">صفحه مورد نظر پیدا نشد</h1>
        <p className="text-secondary mb-4">
          این آدرس وجود ندارد یا به صفحه دیگری منتقل شده است.
        </p>
        <Link to="/" className="btn-clear fw-bold rounded-5">
          بازگشت به صفحه اصلی
        </Link>
      </div>
    </>
  );
};

export default NotFound;
